import { render, staticRenderFns } from "./JdDetails.vue?vue&type=template&id=7c0f4984&"
import script from "./JdDetails.vue?vue&type=script&lang=js&"
export * from "./JdDetails.vue?vue&type=script&lang=js&"
import style0 from "./JdDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports